import React from 'react';

export default function WorldIcon() {
  return (
    <div className="group">
      <svg
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="stroke-[#B9C4D5] hover:stroke-primary hover:text-primary transition-colors duration-300"
      >
        <path
          d="M12.8433 21.507C14.8383 21.5068 16.7767 20.8442 18.3543 19.623C19.9319 18.4018 21.0592 16.6913 21.5593 14.76M12.8433 21.507C10.8483 21.5068 8.9098 20.8442 7.33224 19.623C5.75467 18.4018 4.62734 16.6913 4.12727 14.76M12.8433 21.507C15.3283 21.507 17.3433 17.477 17.3433 12.507C17.3433 7.53696 15.3283 3.50696 12.8433 3.50696M12.8433 21.507C10.3583 21.507 8.34327 17.477 8.34327 12.507C8.34327 7.53696 10.3583 3.50696 12.8433 3.50696M21.5593 14.76C21.7443 14.04 21.8433 13.285 21.8433 12.507C21.8457 10.9591 21.4471 9.43695 20.6863 8.08896M21.5593 14.76C18.8924 16.2383 15.8925 17.0117 12.8433 17.007C9.68127 17.007 6.71027 16.192 4.12727 14.76M4.12727 14.76C3.93801 14.0239 3.84259 13.2669 3.84327 12.507C3.84327 10.902 4.26327 9.39396 5.00027 8.08896M12.8433 3.50696C14.4395 3.50629 16.0072 3.93032 17.3855 4.73552C18.7637 5.54073 19.903 6.69813 20.6863 8.08896M12.8433 3.50696C11.247 3.50629 9.67934 3.93032 8.30107 4.73552C6.9228 5.54073 5.78357 6.69813 5.00027 8.08896M20.6863 8.08896C18.5089 9.97489 15.7238 11.0111 12.8433 11.007C9.84527 11.007 7.10327 9.90696 5.00027 8.08896"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
}